import apiClient from '../client';
import type { RewardSchema } from '@appTypes';

// Rewards API
export type { RewardSchema } from '@appTypes';

/**
 * Fetch all rewards (non-paginated)
 */
export async function fetchRewards(): Promise<{ [key: string]: RewardSchema } | undefined> {
  const response: any = await apiClient.get('/fidelity/rewards', {
    params: { paginated: false },
  });
  return response.data;
}

/**
 * Fetch paginated rewards
 */
export async function fetchPaginatedRewards(params?: { lastDocumentId?: string }): Promise<{ data: { [key: string]: RewardSchema }; lastDocumentId?: string } | undefined> {
  const response: any = await apiClient.get('/fidelity/rewards', {
    params: { paginated: true, lastDocumentId: params?.lastDocumentId },
  });
  return { data: response.data, lastDocumentId: response.lastDocumentId };
}

/**
 * Create a new reward
 */
export async function addReward(params: {
  rewardDescription: { [key: string]: string };
  rewardName: { [key: string]: string };
  rewardPicturesURLs: string[];
  rewardRequiredValue: number;
  rewardStartDate: Date;
  rewardEndDate: Date;
}): Promise<RewardSchema> {
  const response: any = await apiClient.post('/fidelity/rewards', params);
  return response.data;
}

/**
 * Update a reward
 */
export async function updateReward(params: {
  reward: RewardSchema;
  newData: Partial<RewardSchema>;
}): Promise<RewardSchema> {
  const response: any = await apiClient.put(`/fidelity/rewards/${params.reward.rewardId}`, params);
  return response.data;
}

/**
 * Delete a reward
 */
export async function deleteReward(params: { reward: RewardSchema }): Promise<void> {
  await apiClient.delete(`/fidelity/rewards/${params.reward.rewardId}`, {
    data: params,
  });
}

/**
 * Check if a reward can be deleted
 */
export async function canDeleteReward(params: { reward: RewardSchema }): Promise<boolean> {
  const response: any = await apiClient.get(`/fidelity/rewards/${params.reward.rewardId}/can-delete`);
  return response.data;
}

/**
 * Toggle archive status of a reward
 */
export async function toggleArchiveReward(params: { reward: RewardSchema }): Promise<boolean> {
  const response: any = await apiClient.post(`/fidelity/rewards/${params.reward.rewardId}/toggle-archive`, params);
  return response.data;
}
